<template>
  <DatatableReportV3
    title="Permits"
    download-url="/reports/permits"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { customerClassificationColumns } from "@/lib/customerTypes";

import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        columns: [
          {
            data: "status",
            title: "Permit Status",
            searchable: false,
            responsivePriority: 3
          },
          {
            data: "created_date",
            title: "Created Date",
            searchable: false,
            responsivePriority: 10
          },
          { data: "job", responsivePriority: 2 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 6
          },
          { data: "city", responsivePriority: 7 },
          ...customerClassificationColumns(),
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 9 },
          { data: "customer_phone", title: "Phone", responsivePriority: 5 },
          {
            data: "technician",
            filterName: "technician_id",
            responsivePriority: 8
          },
          {
            data: "inspection_date",
            title: "Inspection Date",
            responsivePriority: 4
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
